import Integer from "@zxing/library/esm/core/util/Integer";
import {
  ApiResponse,
  ClientDownloadResponse,
  ClientUIResponse,
  ClientUISingleResponse,
} from "../../models/ApiResponse";
import {
  AddClientFdpTermRequest,
  AddClientRequest,
  AddClientThirdPartyVendorRequest,
  UpdateClientFdpTermRequest,
  UpdateClientRequest,
  UpdateClientThirdPartyVendorRequest,
} from "../../models/requestModels/clientRequest";
import { Client } from "../../models/responseModels/clientsResponse";
import { axiosRequests } from "../axiosRequest";
 
export const ClientAgent = {
  getClientsList: (startDate: string, endDate: string, fdpId: string) =>
    axiosRequests.getWithQueryParam<ClientUIResponse>(
      "/fdc-commandops/clients/get-all-clients",
      {
        params: {
          startDate,
          endDate,
          fdpId,
        },
      }
    ),
 
   
  getDdClientsList: () =>
    axiosRequests.get<ClientUIResponse>(
      "/fdc-commandops/dedicated-delivery/dd-client-details"
    ),
  addClient: (clientData: AddClientRequest) =>
    axiosRequests.post<ApiResponse>(
      "/fdc-commandops/clients/onboard-new-client",
      clientData
    ),
  addClientPcFdpMapping: (clientData: any) =>
    axiosRequests.post<ClientUISingleResponse>(
      "/fdc-commandops/clients/add-client-fdp-parcel-center-mapping",
      clientData
    ),
  editClientPcFdpMapping: (clientData: any) =>
    axiosRequests.put<ClientUISingleResponse>(
      "/fdc-commandops/clients/edit-client-fdp-parcel-center-mapping",
      clientData
    ),
  editClientInformation: (clientData: UpdateClientRequest) =>
    axiosRequests.post<ApiResponse>("/fdc-commandops/clients/edit", clientData),
  clientCsvDownload: (clientData: Client[]) =>
    axiosRequests.post<ClientDownloadResponse>(
      "/clients/downloadCsv",
      clientData
    ),
  clientXlsxDownload: (clientData: Client[]) =>
    axiosRequests.postXlsx<Blob>("/clients/downloadXlsx", clientData),
  updateClient: (clientData: UpdateClientRequest) =>
    axiosRequests.post<ApiResponse>("/clients/updateClient", clientData),
  deleteClient: (clientData: UpdateClientRequest) =>
    axiosRequests.post<ApiResponse>("/clients/deleteClient", clientData),
 
  addClientFdpTerm: (clientData: AddClientFdpTermRequest) =>
    axiosRequests.post<ApiResponse>(
      "/fdc-commandops/clients/add-fdpNetpaymentTerms",
      clientData
    ),
 
    updateClientFdpTerm: (clientData: UpdateClientFdpTermRequest) =>
      axiosRequests.put<ApiResponse>(
        "/fdc-commandops/clients/edit-fdpNetpaymentTerms",
        clientData
      ),
 
      deleteClientNetPaymentTerm: (netPaymentTermId: number) =>
        axiosRequests.delete<ApiResponse>(`/fdc-commandops/clients/deleteFdpNetPaymentTerm/${netPaymentTermId}`),
     
      getClientById: (clientId: number) =>
        axiosRequests.get<{ data: Client }>(`/fdc-commandops/clients/get-client/${clientId}`),
      getClientThirdPartyVendors: (clientId: number) =>
        axiosRequests.get<ClientUIResponse>(
          `/fdc-commandops/public/verizon/get-client/${clientId}`
        ),
   
      // Add a list of third-party vendors
      addClientThirdPartyVendor: (vendorList: AddClientThirdPartyVendorRequest) =>
        axiosRequests.post<ApiResponse>(
          "/fdc-invoice/fdp-invoices/add-vendorList",
          vendorList
        ),
   
      // Edit a list of third-party vendors
      updateClientThirdPartyVendor: (vendorList: UpdateClientThirdPartyVendorRequest) =>
        axiosRequests.put<ApiResponse>(
          "/fdc-invoice/fdp-invoices/edit-vendorList",
          vendorList
        ),
   
      // Delete a specific third-party vendor
      deleteClientThirdPartyVendor: (vendorId: number) =>
        axiosRequests.delete<ApiResponse>(
          `/fdc-invoice/fdp-invoices/deleteVendor/${vendorId}`
        )
     
     
     
};